import { render, staticRenderFns } from "./IlluminationSensor.vue?vue&type=template&id=3ebdfdbe&"
import script from "./IlluminationSensor.vue?vue&type=script&lang=js&"
export * from "./IlluminationSensor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports